export const VALUE_TYPES = {
    TEXT: '1',
    NUM: '2',
    BOOL: '3',
    LIST: '4',
    RANGE: '5',
    TOL: '6',
};
